import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var GET_RECAPTCHAV3_CONFIG = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query GetReCaptchaV3Config {\n        recaptchaV3Config {\n            website_key\n            badge_position\n            language_code\n            forms\n        }\n    }\n"])));
export default {
  getReCaptchaV3ConfigQuery: GET_RECAPTCHAV3_CONFIG
};